export default __webpack_public_path__ + "static/media/Parent_Illustrations-13.5b42e6fe.svg";